
import Vue from 'vue';
import moment from 'moment-timezone';
import BorderSelectCard from '@/components/BorderSelectCard.vue';
import SoftwareOfferReleaseStatusChip from '@/components/SoftwareOfferReleaseStatusChip.vue';
import { DbTimestamp } from '@run-diffusion/shared';
import { mapState } from 'vuex';

export default Vue.extend({
	name: 'DeploymentImageCard',
	props: {
		appOffer: { type: Object, default: null },
		deploymentImage: { type: Object, required: true },
		selected: { type: Boolean, default: false },
	},
	computed: {
		...mapState([
			'user',
		]),
		displayTitle (): string {
			// Snapshots: prefer the user-given title over the auto-derived label
			return this.deploymentImage.snapshotTitle || this.deploymentImage.label;
		},
		releaseDateFormatted (): string {
			const ts: DbTimestamp = this.deploymentImage.releaseDate;
			if (!ts) return '';
			return moment(ts.toMillis()).format('MMM D, YYYY');
		},
		ownerEmailOrId (): string | null {
			// Only relevant for snapshots — system images have user/team null.
			if (!this.user || !this.user.isAdmin) return null;
			return this.deploymentImage.user || this.deploymentImage.team || null;
		},
	},
	components: {
		BorderSelectCard,
		SoftwareOfferReleaseStatusChip,
	},
});
